// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1BVDh","title":"Info_title__1jjhl","links":"Info_links__3lHdo","link":"Info_link__dlkmk","logo":"Info_logo__3uhp6"};